
/* Currency formatter */
window.Shopify = window.Shopify || {};
window.Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }

  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || window.theme?.moneyFormat || '${{amount}}');

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  };

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  };

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  };

  return formatString.replace(placeholderRegex, value);
};

/* ----- cart.js ----- */
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {}

  disconnectedCallback() {}

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#cartDrawerInner',
      },
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        enforceFreeGiftRule(parsedState);
        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const sectionEL = document.getElementById(section.id);
          if (!sectionEL) return;

          const elementToReplace = sectionEL.querySelector(section.selector) || sectionEL;
          if (!elementToReplace) return;

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        /* const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('{{ quantity }}', updatedValue);
          }
        }
        this.updateLiveRegions(line, message); */

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(error => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (!errors) return;
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);

    if (lineItemError) {
      if (typeof message !== 'undefined' && message !== '') lineItemError.removeAttribute('hidden');
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (!cartStatus) return;

    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    if (!(html || selector)) return;
    const $selector = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!$selector) return;
    return $selector.innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    mainCartItems.classList.add('pointer-events');

    const cartItems = this.querySelectorAll(`#CartItem-${line}`);
    cartItems.forEach((item) => item.classList.add('loading'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items');
    mainCartItems?.classList.remove('pointer-events');

    const cartItems = this.querySelectorAll(`#CartItem-${line}`);
    cartItems.forEach((item) => item.classList.remove('loading'));
    document.dispatchEvent(new CustomEvent('CartItemsOnChange'));
    document.dispatchEvent(new CustomEvent('cart-disable-loading'));
  }
};

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

/* ----- quantity-popover.js ----- */
if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.variantInfo = this.querySelector('.quantity-popover-container');
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop && this.mql.matches) {
          this.popoverInfo.addEventListener('mouseenter', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonMobile.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.variantInfo.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.variantInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-expanded', !isExpanded);

        this.popoverInfo.toggleAttribute('hidden');

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        button.classList.toggle('quantity-popover__info-button--open');

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isChild = this.variantInfo.contains(event.relatedTarget);

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!event.relatedTarget || !isChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}

/* ---- cart-drawer.js ----- */
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    window.addEventListener('keyup', (evt) => evt.code === 'Escape' && document.documentElement.classList.contains('cart-drawer--active') && this.close());
    this.querySelector('#cartDrawerOverlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    if (window.location.pathname === '/cart') return;

    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    /* cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    }); */
  }

  open(triggeredBy) {
    document.dispatchEvent(new CustomEvent('cart-drawer-opened'));

    cartDrawerInner.scroll(0, 0);

    window.inView();
    window.loadSwiper();

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    requestAnimationFrame(() => {
      lockScrollEnable();
      document.documentElement.classList.add('cart-drawer--active');
    });

    fetch(window.Shopify.routes.root + 'cart.js')
      .then((response) => response.json())
      .then((cartData) => {
        window.publish(window.PUB_SUB_EVENTS.cartView, {
          source: 'drawer-open',
          cartData
        });
      })
      .catch((e) => {
        console.error(e);
      });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
        window.updateCartCount();
      },
      { once: true }
    );
  }

  close() {
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    document.documentElement.classList.remove('cart-drawer--active');
    lockScrollDisable();
    window.updateCartCount();
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cart-drawer-closed'));
    }, 250);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#cartDrawerOverlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#cartDrawerInner',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.aftershipHidden = false;
    this.limitedUpdate = this.hasAttribute('data-limited-update') && this.dataset.limitedUpdate === 'true';
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    if (!this.limitedUpdate) {
      this.toggleAddButton(true, '', false);
      // this.updatePickupAvailability();
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      /* if (!this.limitedUpdate) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } */
    } else {
      /* this.updateMedia(); */
      this.updateOptionsLegend();
      this.updateVariantInput();
      this.renderProductInfo();

      if (!this.limitedUpdate) {
        this.updateSku();
        this.updateURL();
        /* this.renderProductInfo(); */
      } else {
        this.updateSetInputs();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateOptionsLegend() {
    this.currentVariant.options.forEach((option, index) => {
      const replaceText = this.getOptionNameReplaceText() && this.getOptionNameReplaceText().find(o => option === o.title);
      const el = this.querySelector(`[data-product-option-active="${index}"]`);
      const checked = this.querySelector(`fieldset[data-product-option="${index}"] input[type="radio"]:checked`);
      const inv = checked ? this.querySelector(`label[for="${checked.id}"]`)?.dataset.inventory : '';
      const loadedMessage = this.querySelector('.product-inventory__message');
      if (loadedMessage) {
        loadedMessage.remove();
      }
      el ? el.innerText = (replaceText ? replaceText.replace : option) + (inv ? `: ${inv}` : '') : null;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    window.publish(PUB_SUB_EVENTS.variantChange, {
      sectionId: this.dataset.section,
      currentVariant: this.currentVariant,
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateSku() {
    if (!(this.currentVariant && document.getElementById('productSku'))) return;
    productSku.innerText = 'Style Number: ' + this.currentVariant.sku.split('-')[0];
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    const sectionId = this.dataset.section;
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${sectionId}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut || 'Sold out');
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
      if (this.currentVariant && !this.currentVariant.available) {
        document.dispatchEvent(new CustomEvent('restyleAftershipLoadingStart'));
        this.aftershipHidden = true;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
      if (this.aftershipHidden) document.dispatchEvent(new CustomEvent('restyleAftership'));
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"][data-json="product-variants"]').textContent);
    return this.variantData;
  }

  getOptionNameReplaceText() {
    this.optionNameReplaceText = this.optionNameReplaceText || JSON.parse(this.querySelector('[type="application/json"][data-json="option-name-replace-text"]').textContent);
    return this.optionNameReplaceText;
  }

  updateSetInputs() {
    this.querySelectorAll(':checked').forEach(input => {
      const setInput = document.querySelector(`input[data-form-id="${input.getAttribute('form')}"][name$="id"]`);
      if (setInput) setInput.value = this.currentVariant.id;
    });
  }
};

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll('input'));
      return inputs.length === 1 ? inputs[0].value : inputs.length && inputs.find((radio) => radio.checked).value;
    });
  }
};

customElements.define('variant-radios', VariantRadios);

/* ----- globals ----- */
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function lockScrollEnable() {
  window.pageY = window.scrollY;
  document.body.style.left = 0;
  document.body.style.right = 'var(--scrollbar-width)';
  document.body.style.top = `-${window.pageY}px`;
  document.body.style.position = 'fixed';
}

function lockScrollDisable() {
  document.body.style.position = null;
  document.body.style.left = null;
  document.body.style.right = null;
  document.body.style.top = null;
  window.scrollTo(0, window.pageY);
}

function loadMinicart() {
  fetch(`${window.Shopify.routes.root}?sections=cart-drawer`)
    .then(response => response.json())
    .then(data => document.querySelector('#cartDrawerInner').innerHTML = (new DOMParser().parseFromString(data['cart-drawer'], 'text/html').querySelector('#cartDrawerInner').innerHTML))
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; /* If not TAB key */
    /* On the last focusable element and tab forward, focus the first element. */
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    /*  On the first focusable element and tab backward, focus the last element. */
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  if (elementToFocus) elementToFocus.focus();
  // if (
  //   elementToFocus.tagName === 'INPUT' &&
  //   ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
  //   elementToFocus.value
  // ) {
  //   elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  // }
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

window.handleProductSet = async (variantId, btn) => {
  var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  if (btn) {
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');
  }

  const id = parseInt(variantId);
  if (!id) return;

  const payload = { id, quantity: 1 };
  if (cart) {
    payload.sections = cart.getSectionsToRender().map(s => s.id);
    payload.sections_url = window.location.pathname;
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
  .then(response => {
    if (!response.ok) {
      console.error('upsell error', response.status);
    }
    return response.json();
  })
  .then(response => {
    publish(PUB_SUB_EVENTS.cartUpdate, { productVariantId: id, cartData: response });
    if (cart) {
      cart.renderContents(response);
    }
  })
  .catch(error => {
    console.error(error);
  })
  .finally(() => {
    if (btn) {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading')
    }
  });
};

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.cart-item-set__upsell-button');
  if (!btn) return;
  e.preventDefault();
  window.handleProductSet(btn.dataset.variantId, btn);
});

function getHiddenUpsell() {
  return sessionStorage.getItem('hiddenUpsell');
}
function hideUpsell() {
  const id = getHiddenUpsell();
  if (id) document.querySelector(`.cart-item__upsell[data-set-upsell-id="${id}"]`).remove();
}
document.addEventListener('click', event => {
  const btn = event.target.closest('[data-set-upsell-close]');
  if (!btn) return;
  event.preventDefault();
  const row = btn.closest('.cart-item__upsell');
  if (row) {
    sessionStorage.setItem('hiddenUpsell', row.dataset.setUpsellId);
    row.remove();
  }
});

document.addEventListener('DOMContentLoaded', hideUpsell);
new MutationObserver(hideUpsell).observe(document.body, { childList: true, subtree: true });

class NfsItem extends HTMLElement {
  constructor () {
    super();
  }
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('.cart-nfs__item-variant:not([disabled])');
      if (!btn) return;

      e.preventDefault();
      if (btn.dataset.eligible !== 'true') return;

      const id = btn.dataset.nfsVariantId;
      if (id && window.handleProductSet) {
        window.handleProductSet(id, btn);
      }
    });

    const variants = this.querySelectorAll('.cart-nfs__item-variant[data-eligible="true"]:not([disabled])');
    if (variants.length === 1 && this.getAttribute('data-auto-add-single-variant') !== 'false') {
      variants[0].click();
    }
  }
}

function enforceFreeGiftRule(cart) {
  const nfsData = window.NFS;
  if (!nfsData) return;

  const total = cart.total_price ?? cart.items_subtotal_price ?? 0;
  const gifts = (cart?.items || []).filter(i => i.product_id === nfsData.productId).map(i => i.id);

  if (!(total < nfsData.thresholdCents && gifts.length)) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: Object.fromEntries(gifts.map(id => [id, 0])) })
  })
  .then(() => {
    document.querySelector('cart-items')?.onCartUpdate();
    return loadMinicart();
  })
  .catch(console.error);
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton && this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton) this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && this.submitButton) this.submitButton.removeAttribute('aria-disabled');
            this.closest('.quickadd--loading')?.classList.remove('quickadd--loading');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        const isQuickadd = this.closest('quickadd-sizes') !== null;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          if (isQuickadd && errorMessage.includes('is already sold out')) errorMessage = 'Sorry, size is sold out';
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

class ReleaseCowntdown extends HTMLElement {
  constructor() {
    super();
    this.enabled = false;
    this.timerId;
    this.productCardEl = this.closest('.product-card');
    this.dateStr = this.dataset.dropDatetime;
    if (!this.dateStr.includes('+')) {
      this.dateStr = `${this.dateStr}${window.theme.timeZone}`;
    }
    this.targetDate = new Date(this.dateStr);
    this.targetMs = this.targetDate.getTime();

    if (!Number.isNaN(this.targetMs) && this.targetMs >= Date.now()) {
      this.enabled = true;
    }
  }

  connectedCallback() {
    if (this.enabled) {
      this.tick();
      this.timerId = setInterval(this.tick.bind(this), 1000);
      this.classList.remove('hide');

      if (this.productCardEl) {
        this.productCardEl.classList.add('is-drop');
      }
    }
  }

  disconnectedCallback() {
    clearInterval(this.timerId);
  }

  tick() {
    const diff = this.targetMs - Date.now();
    if (diff <= 0) {
      if (countdown) countdown.textContent = "Buy Now";
      if (timerId) clearInterval(timerId);
      return;
    }
    this.render(diff);
  }

  render(diff) {
    const month = this.targetDate.toLocaleDateString("en-US", { month: "short" });
    const dayNum = this.targetDate.toLocaleDateString("en-US", { day: "numeric" });
    const day = Math.floor(diff / 86400000);
    const hour = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    this.innerHTML = `
      <div class="releases__date flex flex--align-center tt--upper flex--justify-center width" style="--padding-mobile: 4px 0; --flex-direction-desktop: column; --flex-direction-mobile: row; font-weight: 500; height: 100%; color: #000; background: #fff; --width-mobile: 100%; --width-desktop: 80px;">
        <span class="releases__month font-size" style="--font-size-desktop: 14px; --font-size-mobile: 12px;">${month}</span>
        <span class="hide-desktop">&nbsp;</span>
        <span class="releases__day font-size" style="--font-size-desktop: 20px; --font-size-mobile: 12px;">${dayNum}</span>
      </div>
      <div class="countdown-timer flex padding" style="--flex-direction: row; --padding-mobile: 8px 0;">
        <div class="countdown-timer__block">
          <span class="countdown-timer__days font-size" style="--font-size-desktop: 20px; --font-size-mobile: 16px;">${String(day).padStart(2, "0")}</span>
          <span class="label font-size tt--upper" style="--font-size: 10px;">days</span>
        </div>
        <span class="seperator">:</span>
        <div class="countdown-timer__block">
          <span class="countdown-timer__hour font-size" style="--font-size-desktop: 20px; --font-size-mobile: 16px;">${String(hour).padStart(2, "0")}</span>
          <span class="label font-size tt--upper" style="--font-size: 10px;">hrs</span>
        </div>
        <span class="seperator">:</span>
        <div class="countdown-timer__block">
          <span class="countdown-timer__minutes font-size" style="--font-size-desktop: 20px; --font-size-mobile: 16px;">${String(minutes).padStart(2, "0")}</span>
          <span class="label font-size tt--upper" style="--font-size: 10px;">mins</span>
        </div>
        <span class="seperator">:</span>
        <div class="countdown-timer__block">
          <span class="countdown-timer__seconds font-size" style="--font-size-desktop: 20px; --font-size-mobile: 16px;">${String(seconds).padStart(2, "0")}</span>
          <span class="label font-size tt--upper" style="--font-size: 10px;">sec</span>
        </div>
      </div>
    `;
  }
}

customElements.define('release-timer', ReleaseCowntdown);

class ReleaseDialog extends HTMLElement {
  constructor() {
    super();
    this.form = document.getElementById("releaseSignupForm");
    this.statusText = document.getElementById("releaseSignupMsg");
    this.popup = document.getElementById("releasesPopup");
    this.popupClose = document.getElementById("releasesPopupClose");
    this.brandSlotLeft = document.getElementById("releasesPopupBrandImage");
    this.brandSlotInline = document.getElementById("releases-signup-image");
    this.data = null;
  }

  connectedCallback () {
    window.subscribe(window.PUB_SUB_EVENTS.openReleaseDialog, event => {
      this.data = event.releaseData;

      console.log(this.data);

      if (this.form) {
        this.form.release_id.value = this.data.releaseId;
        this.form.release_name.value = this.data.releaseName;
        this.form.brand.value = this.data.brand;
        this.form.is_raffle.value = this.data.isRaffle || "false";
      }

      this.showPopup();
    });

    document.addEventListener("click", e => {
      if (!e.target.matches("[data-release-id]")) return;

      window.publish(window.PUB_SUB_EVENTS.openReleaseDialog, {
        source: 'release-tile',
        releaseData: e.target.dataset,
      });
    });

    this.popupClose.addEventListener("click", this.hidePopup.bind(this));

    this.popup.addEventListener("click", e => {
      if (e.target === this.popup) this.hidePopup();
    });

    this.popup.addEventListener("cancel", e => {
      e.preventDefault();
      this.hidePopup();
    });

    this.form.addEventListener("submit", async e => {
      e.preventDefault();
      this.showStatus("");
      document.getElementById("signUpBtn").classList.add("is-loading");
      const emailRaw = (this.form.email.value).trim();
      const phoneRaw = (this.form.phone?.value).trim();
      const email = emailRaw;
      const phone = window.klaviyoNormalizePhone(phoneRaw);

      if (!email && !phone) {
        return this.showStatus("Please enter an email or a mobile number.");
      }

      const preferencesValues = Array.from(this.form.querySelectorAll('[name="pref"]:checked')).map(x => x.value) || [];
      const preferences = JSON.stringify(preferencesValues);
      const meta = {
        releaseId: this.form.release_id.value,
        releaseName: this.form.release_name.value,
        brand: this.form.brand.value,
        isRaffle: String(this.form.is_raffle.value || "false").toLowerCase() === "true"
      };

      try {
        await this.createOrUpdateProfile({ email, phone, preferences });

        const subs = [];
        if (email) {
          subs.push(
            this.subscribeProfileToList({
              listId: window.klaviyoDefaultListID,
              email,
              phone: "",
              preferences
            })
          );
        }
        if (phone) {
          subs.push(
            this.subscribeProfileToList({
              listId: window.klaviyoDefaultSMSListID,
              email: "",
              phone,
              preferences
            })
          );
        }

        await Promise.all(subs);
        if (email) this.sendSubscribedMetric(email, meta);
        document.getElementById("signUpBtn").classList.remove("is-loading");
        this.showStatus(window.theme.strings.releases_success_message, true);
        this.form.reset();
      } catch (err) {
        document.getElementById("signUpBtn").classList.remove("is-loading");
        this.showStatus(window.theme.strings.releases_error_message);
        console.error(err);
      }
    });
  }

  showPopup() {
    this.setBrandImages();
    if (!this.popup.open) this.popup.showModal();
  }

  hidePopup() {
    if (this.popup.open) this.popup.close();
  }

  setBrandImages() {
    const imageReg = this.data.brand.toLowerCase().trim().replace(/[\u200B-\u200D\uFEFF]/g, "");
    const img = `<img src="https://culture-kings-static.imgix.net/images/logos-centre/brand-${imageReg}.jpg?auto=compress,format&width=200" alt="" width="120">`;
    if (this.brandSlotInline) this.brandSlotInline.innerHTML = img;

    const leftImg = `<img src="${this.data.releaseImage}" alt="">`;
    if (this.brandSlotLeft) this.brandSlotLeft.innerHTML = leftImg;
  }

  showStatus(message, isSuccess = false) {
    if (!this.statusText) return;
    this.statusText.textContent = message;
    this.statusText.style.color = isSuccess ? "#1a7f37" : "#b42318";
  }

  async klaviyoRequest(endpoint, payload) {
    const res = await fetch(
      `https://a.klaviyo.com/client/${endpoint}?company_id=${window.klaviyoCompanyID}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "revision": "2025-07-15"
        },
        body: JSON.stringify(payload)
      }
    );
    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Klaviyo ${endpoint} failed: ${res.status} ${text}`);
    }
    return res.json().catch(() => ({}));
  }

  buildProfileAttributes({ email, phone, preferences }) {
    const attrs = {
      properties: {
        "$consent_method": "CK Signup Form",
        "$source": "release_signup",
        "Product Preferences": preferences ?? "[]"
      }
    };
    if (email) attrs.email = email;
    if (phone) attrs.phone_number = phone;
    return attrs;
  }

  createOrUpdateProfile({ email, phone, preferences }) {
    return this.klaviyoRequest("profiles/", {
      data: {
        type: "profile",
        attributes: this.buildProfileAttributes({ email, phone, preferences })
      }
    });
  }

  subscribeProfileToList({ listId, email, phone, preferences }) {
    const profileAttrs = this.buildProfileAttributes({ email, phone, preferences });
    return this.klaviyoRequest("subscriptions/", {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "release_signup",
          profile: { data: { type: "profile", attributes: profileAttrs } }
        },
        relationships: { list: { data: { type: "list", id: listId } } }
      }
    });
  }

  sendSubscribedMetric(email, data) {
    this.klaviyoRequest("events/", {
      data: {
        type: "event",
        attributes: {
          metric: { data: { type: "metric", attributes: { name: "Subscribed to Release" } } },
          profile: { data: { type: "profile", attributes: { email } } },
          properties: {
            releaseId: data.releaseId,
            releaseName: data.releaseName,
            brand: data.brand,
            isRaffle: data.isRaffle
          }
        }
      }
    }).catch(() => {});
  }
}

customElements.define('release-dialog', ReleaseDialog);

(() => {
  const onScroll = () => {
    if (window.menuToggling) return;


    if (window.pageYOffset > window.headerScrolledThreshold) {
      document.documentElement.classList.add('header--scrolled');
    } else {
      document.documentElement.classList.remove('header--scrolled');
    }

    if (window.pageYOffset > 300 + window.headerScrolledThreshold) {
      document.documentElement.classList.add('header--scrolled--after');
    } else {
      document.documentElement.classList.remove('header--scrolled--after');
    }

    const scrollTop = window.pageYOffset;

    /* scroll direction */
    window.scrollDirection = scrollTop > lastScrollTop ? 'down' : 'up';
    document.documentElement.dataset.scrollDirection = window.scrollDirection;
    lastScrollTop = window.pageYOffset;
  };

  const inViewVideo = (el, src) => {
    const $video = el.closest('video');

    if (!$video) return;
    if (typeof src !== 'undefined') $video.src = el.dataset.inViewVideoSrc;

    if (!$video.hasAttribute('data-autoplay')) return;
    /* $video.removeAttribute('controls'); */
    $video.play();
  };

  window.lazyLoadScript = obj => {
    const isLoaded = document.head.querySelector(`[data-in-view-script-name='${obj.src}']`);
    const cb = obj.callback && typeof window[obj.callback] === 'function' ? window[obj.callback] : null;

    if (isLoaded) {
      if (cb) cb();
      return;
    }

    if (!obj.hasOwnProperty('src')) {
      // only need to fire the callback, no script to load
      if (cb) cb();
      return;
    }

    const $script = document.createElement('script');
    $script.dataset.inViewScriptName = obj.src;
    $script.type = obj.type || 'text/javascript';
    if (obj.defer) $script.defer = true;
    else if (obj.async) $script.async = true;
    $script.src = obj.src;
    document.head.appendChild($script);

    if (cb) $script.onload = requestAnimationFrame(() => {
      cb()
    });
  }

  const inViewScript = obj => {
    lazyLoadScript(obj);
  };

  window.loadSwiper = () => {
    /* load swiper if needed */
    if (!window.swiperLoaded && typeof Swiper !== 'function') {
      const $script = document.createElement('script');
      $script.async = true;
      $script.src = window.assetUrls['swiper.js'];
      document.head.appendChild($script);
      window.swiperLoaded = true
    }

    const swiperIsReady = new Promise(resolve => {
      let timer = setInterval(() => {
        if (typeof Swiper === 'function') {
          clearInterval(timer);
          return resolve();
        }
      }, 30)
    });

    swiperIsReady.then(() => {
      window.swipers();
    }).catch(error => {
      console.error('Something went wrong', error);
    })
  };

  window.onSwatchClick = (e, data, cardEl) => {
    if (e.target.classList.contains('swatches__item--active')) return;
    e.preventDefault();
    window.productCardLoad(e);
  };

  window.publishProductsData = data => {
    /* USAGE:
      window.addEventListener('publishProductsData', data => {
        console.log('<gtm-helper> publishProductsData listener', data.detail);
      });
    */
    window.dispatchEvent(new CustomEvent('publishProductsData', {
      detail: data,
    }));
    window.publish(window.PUB_SUB_EVENTS.viewItemList, {
      source: data.section,
      products: data.products,
    });
  };

  /* swipers init via data-swiper={options} */
  window.swiperEls = [];
  window.swipers = () => {
    document.querySelectorAll('[data-swiper]:not(.swiper-initialized)').forEach((el, index) => {
      window.swiperEls[index] = new Swiper(el, Object.assign({}, {
        a11y: true,
        observer: true,
        slidesPerView: 'auto',
        threshold: 8,
      }, JSON.parse(el.dataset.swiper)));

      const changeEvent = el.getAttribute('data-swiper-slide-change');

      if (changeEvent && window.hasOwnProperty(changeEvent) && typeof window[changeEvent] === 'function') {
        window.swiperEls[index].on('slideChange', function(e) {
          window[changeEvent](e);
        })
      }
    });
  };

  window.inView = () => {
    /* add .in-view class to [data-in-view] els as they enter the viewport */
    const inViewEls = document.querySelectorAll('[data-in-view]');

    const inViewObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');

          if (entry.target.hasAttribute('data-autoplay') || entry.target.hasAttribute('data-in-view-video-src')) {
            inViewVideo(entry.target, entry.target.dataset.inViewVideoSrc);
          }

          if (entry.target.hasAttribute('data-in-view-swiper')) {
            loadSwiper();

            inViewObserver.unobserve(entry.target);
          }

          if (entry.target.hasAttribute('data-in-view-script')) {
            inViewScript(JSON.parse(entry.target.dataset.inViewScript));
          }
        } else {
          if (entry.target.hasAttribute('data-autoplay') && entry.target.paused == false) {
            entry.target.pause()
          }
        }
      });
    });

    inViewEls.forEach(el => inViewObserver.observe(el));
  };

  class QuickaddSizes extends HTMLElement {
    constructor() {
      super();
      this.detailsEl = this.querySelector('details');
      this.summaryEl = this.querySelector('summary');
      this.longPressTimer = null;
    }

    // Make sure long taps open details for mobile
    connectedCallback() {
      // Prevent default context menu on long press
      this.summaryEl.addEventListener('contextmenu', e => {
        e.preventDefault();
      });

      this.summaryEl.addEventListener('touchstart', () => {
        // Clear any existing timer to prevent multiple triggers
        clearTimeout(this.longPressTimer);
        this.longPressTimer = setTimeout(() => {
          // Open the details element after the long press duration
          this.detailsEl.open = true;
        }, 500);
      });

      this.summaryEl.addEventListener('touchend', () => {
        // Clear the timer if the touch ends before the long press duration
        clearTimeout(this.longPressTimer);
      });

      this.summaryEl.addEventListener('touchmove', () => {
        // Clear the timer if the finger moves during the press
        clearTimeout(this.longPressTimer);
      });
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    customElements.define('cart-remove-button', CartRemoveButton);
    customElements.define('cart-items', CartItems);
    customElements.define('cart-drawer', CartDrawer);
    customElements.define('nfs-item', NfsItem);
    customElements.define('quickadd-sizes', QuickaddSizes);

    window.lastScrollTop = window.pageYOffset;

    onScroll();
    inView();

    window.addEventListener('scroll', () => {
      onScroll();
    }, { passive: true });
  });

  window.addEventListener('keyup', e => {
    if (e.key === 'Escape') document.dispatchEvent(new CustomEvent('onEsc'));
  });

  window.updateCart = () => {
    /* reload the minicart */
    if (document.querySelector("#cartDrawerInner")) {
      window.loadMinicart();

      /* open the minicart */
      document.querySelector('cart-drawer')?.open();
    } else {
      window.setCartFooterHeight();

      /* reload the cart page */
      document.querySelector('cart-items')?.onCartUpdate();

      requestAnimationFrame(() => {
        window.fixCartFooter();
      });
    }

    /* update cart bubble count in header */
    fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        document.querySelector('#cart-icon-bubble').innerHTML = html.querySelector('#shopify-section-cart-icon-bubble').innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });

    /* update free shipping message in announcement bar */
    fetch(`${routes.cart_url}.js`)
      .then(response => response.json())
      .then(data => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'product-form-cart-total',
          cartData: data,
        });
      });
  };

  window.updateCartCount = (delay = 300) => {
    requestAnimationFrame(() => {
      const $count = document.querySelector('[data-cart-icon-bubble-count]');
      const count = $count ? $count.innerText : 1
      /* wait for cart-drawer transition to finish then update data-cart-count which is used to adjust the padding next to cart icon in header*/
      setTimeout(() => {
        document.documentElement.dataset.cartCount = count
      }, delay);
    });
  }

  document.addEventListener('CartItemsOnChange', () => {
    window.updateCartCount();
  })
})();